import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import GlobalStyle from '../styles/global';
import SelecionarEmocionador from '../components/SelecionarEmocionador';
import SelecionarMoedas from '../components/SelecionarMoedas';
import JustificarEmocao from '../components/JustificarEmocao';
import Confirmacao from '../components/Confirmacao';
import { Container } from '../styles/styles';
import { ContentSection, Content } from '../styles/styles';
import { API_URL } from '../controllers/api';
import { getUserData } from '../controllers/userController';

const LoadingSpinner = styled.div`
  border: 3px solid #f3f3f3;
  border-top: 3px solid #4CAF50;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingText = styled.p`
  color: #666;
  font-size: 14px;
  margin-top: 15px;
  text-align: center;
`;

// Componente de Loading
const LoadingComponent = ({ message = "Processando..." }) => (
  <Container direction="column" width="100%">
    <ContentSection fullWidth padding="10px">
      <Content padding="40px" style={{ textAlign: 'center' }}>
        <LoadingSpinner />
        <LoadingText>{message}</LoadingText>
      </Content>
    </ContentSection>
  </Container>
);

function Emocionar({ onClose }) {
  const [step, setStep] = useState(1);
  const [emocionador, setEmocionador] = useState(null);
  const [moedas, setMoedas] = useState([]);
  const [justificationData, setJustificationData] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [moedasType, setMoedasType] = useState('Moedas Minha Equipe');
  const [userData, setUserData] = useState({});
  const [loadingUser, setLoadingUser] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    const fetchUserData = async () => {
      if (user?.idusuario) {
        try {
          setLoadingUser(true);
          const userInfo = await getUserData(user.idusuario);
          setUserData(userInfo || {});
        } catch (error) {
          setErrorMessage("Falha ao carregar dados do usuário.");
        } finally {
          setLoadingUser(false);
        }
      } else {
        setLoadingUser(false);
      }
    };
    
    fetchUserData();
  }, [user?.idusuario]);

  const handleSelectEmocionador = (selectedEmocionador) => {
    setEmocionador(selectedEmocionador);
    setStep(2);
  };

  const handleConfirmMoedas = (selectedMoedas) => {
    setMoedas(selectedMoedas);
    setStep(3);
  };

  const handleJustificationSubmit = async (justification) => {
    setJustificationData(justification);
    setLoadingSubmit(true);
    setErrorMessage(null);

    try {
      const formData = new FormData();
      formData.append('distribuidorId', user.idusuario);
      formData.append('receptorId', emocionador.id);
      formData.append('moedas', JSON.stringify(moedas));
      formData.append('tipo_moeda', moedasType);
      formData.append('motivo', justification.reason);
      formData.append('descricao', justification.justification);
      formData.append('data_emocao', justification.date);
      if (justification.file) {
        formData.append('file', justification.file);
      }

      const response = await fetch(API_URL + '/emocionarMoedas', {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        setStep(4);
      } else {
        setErrorMessage(result.mensagem || "Ocorreu um erro ao enviar os dados.");
      }
    } catch (error) {
      setErrorMessage(`Erro de comunicação com a API: ${error.message}`);
    } finally {
      setLoadingSubmit(false);
    }
  };

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleClose = () => {
    window.location.href = '/';
  };

  return (
    <>
      <GlobalStyle />
      <Container bgColor="#fff" fullWidth direction="column" align="center" justify="center" padding="0px">
        
        {loadingUser ? (
          <LoadingComponent message="Carregando dados do usuário..." />
        ) : loadingSubmit ? (
          <LoadingComponent message="Enviando emoção..." />
        ) : (
          <>
            {step === 1 && <SelecionarEmocionador onSelect={handleSelectEmocionador} onClose={handleClose} />}
            {step === 2 && (
              <SelecionarMoedas
                emocionador={emocionador}
                onConfirm={handleConfirmMoedas}
                onBack={handleBack}
                errorMessage={errorMessage}
                onClose={handleClose}
                moedasType={moedasType}
                setMoedasType={setMoedasType}
                isGestor={userData.cargo === "Gestor"}
              />
            )}
            {step === 3 && (
              <JustificarEmocao
                emocionador={emocionador}
                moedas={moedas}
                onSubmit={handleJustificationSubmit}
                onBack={handleBack}
                errorMessage={errorMessage}
                onClose={handleClose}
                moedasType={moedasType}
              />
            )}
            {step === 4 && (
              <Confirmacao 
                emocionador={emocionador} 
                moedas={moedas} 
                onClose={handleClose}
                moedasType={moedasType}
              />
            )}
          </>
        )}
      </Container>
    </>
  );
}

export default Emocionar;